import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Primary as PrimaryButton, Secondary, Text } from "@cinch-labs/design-system";
import React from "react";
import styles from "./landing-feature-error-page.module.css";
export function LandingFeatureErrorPage(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, _hasCta = param.hasCta, hasCta = _hasCta === void 0 ? false : _hasCta, ctaHref = param.ctaHref, ctaText = param.ctaText, searchCarsCtaText = param.searchCarsCtaText;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["container"],
        role: "main",
        children: [
            /*#__PURE__*/ _jsx(Title, {
                title: title
            }),
            /*#__PURE__*/ _jsx(Subtitle, {
                subTitle: subTitle
            }),
            /*#__PURE__*/ _jsx(Image, {
                image: image
            }),
            /*#__PURE__*/ _jsx(CTA, {
                hasCta: hasCta,
                ctaText: ctaText,
                ctaHref: ctaHref,
                searchCarsCtaText: searchCarsCtaText
            })
        ]
    });
}
function Title(param) {
    var title = param.title;
    if (!title) return null;
    return /*#__PURE__*/ _jsx(Text, {
        element: "h1",
        className: styles["errorPageTitle"],
        children: title
    });
}
function Subtitle(param) {
    var subTitle = param.subTitle;
    if (!subTitle) return null;
    return /*#__PURE__*/ _jsx(Text, {
        className: styles["errorPageSubTitle"],
        element: "h2",
        children: subTitle
    });
}
function Image(param) {
    var Image = param.image;
    if (!Image) return null;
    return /*#__PURE__*/ _jsx("span", {
        className: styles["errorPageImage"],
        children: /*#__PURE__*/ _jsx(Image, {})
    });
}
function CTA(param) {
    var hasCta = param.hasCta, ctaText = param.ctaText, ctaHref = param.ctaHref, searchCarsCtaText = param.searchCarsCtaText;
    if (!hasCta || !ctaText || !ctaHref) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PrimaryButton, {
                element: "a",
                href: ctaHref,
                children: ctaText
            }),
            /*#__PURE__*/ _jsx(SearchCarsCTA, {
                searchCarsCtaText: searchCarsCtaText
            })
        ]
    });
}
function SearchCarsCTA(param) {
    var searchCarsCtaText = param.searchCarsCtaText;
    if (!searchCarsCtaText) return null;
    return /*#__PURE__*/ _jsx(Secondary, {
        element: "a",
        href: "/used-cars",
        children: searchCarsCtaText
    });
}
